import React, { useState } from 'react';
import Modal from 'react-native-modal';
import { View, Text, StyleSheet, Image, TextInput } from 'react-native';

import { doPost } from '../services/api/OMSAPI';
import { loaderModal } from '../services/AlertLoaderService';
import { addFontFamilyStyle, getImagePath } from '../services/CommonUtils';

import { PrimaryCTA } from '../widgets/CommonCTA';
import { CloseIcon } from '../widgets/Common-Widget';

import { AppVersionCode } from '../constants/AppConstants';
import { NegativeReviews, PositiveReviews, ReviewLabel } from '../constants/BottomSheetSurveyContent';

import AppTheme from '../../AppTheme';
import OmsStyles from '../../OmsStyle';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import Colors from '../constants/AppColors';

const RateOrderModal = (props) => {

    const ratingList = [1, 2, 3, 4, 5];
    const orderData = props.orderData
    const showRatingModal = props?.showRatingModal
    const hasBackdrop = props?.hasBackdrop ?? true

    const closeModal = props?.closeModal
    const primaryAction = props?.primaryAction

    const [selectedRating, setSelectedRating] = useState(5);
    const [otherRatingDescp, updateOtherRatingDescp] = useState('')
    // other descp is not passing in params yet to be implemented.

    const [selectedOption, updateSelectedOption] = useState({
        selectedIndexList: [], selectedOptions: [], exclusiveIndex: -1
    })

    const updateOrderRating = () => {
        loaderModal.setLoader(true);
        closeRateModelAndReset();
        let params = {
            appVersionCode: AppVersionCode,
            orderId: orderData['oid'],
            feedback: {
                msg: getSelectedMsg(selectedOption.selectedOptions, otherRatingDescp),
                rating: selectedRating
            },
            orderReceived: orderData?.markedDelivered ?? false
        }
        doPost('order/rate', params).then((response: any) => {
            if (response != null && response != '')
                primaryAction(response['order'])
            loaderModal.setLoader(false);
        })
    }

    function getSelectedMsg(selectedOptions, otherRatingDescp) {
        if (otherRatingDescp)
            selectedOptions.push(otherRatingDescp)
        return selectedOptions
    }

    function checkOptionSelected(index) {
        var indexList: any = selectedOption.selectedIndexList;
        return indexList.includes(index);
    }

    function closeRateModelAndReset() {
        setSelectedRating(5);
        updateOtherRatingDescp('');
        updateSelectedOption({
            selectedIndexList: [],
            selectedOptions: [],
            exclusiveIndex: -1
        })
        closeModal()
    }

    function onOptionSelected(index, option) {
        // As of now, now option has exclusive map true
        // for future purpose keeping this function.
        var exclusiveIndex = -1, isOptionAlreadySelected = false,
            indexList: any = selectedOption.selectedIndexList,
            optionsList: any = selectedOption.selectedOptions;
        for (var i = 0; i < indexList.length; i++) {
            if (indexList[i] == index) {
                indexList.splice(i, 1);
                optionsList.splice(i, 1);
                isOptionAlreadySelected = true;
                updateOtherRatingDescp('')
                updateSelectedOption({
                    selectedIndexList: indexList,
                    selectedOptions: optionsList,
                    exclusiveIndex: -1
                });
            }
        }
        if (indexList.includes(selectedOption.exclusiveIndex)) {
            indexList.splice(indexList.indexOf(selectedOption.exclusiveIndex), 1);
            optionsList.splice(indexList.indexOf(selectedOption.exclusiveIndex), 1);
        }
        if (!isOptionAlreadySelected) {
            if (option.exclusive) {
                indexList.splice(0, indexList.length);
                optionsList.splice(0, optionsList.length);
                exclusiveIndex = index
            }
            indexList.push(index);
            optionsList.push(option['value']);
            updateSelectedOption({
                selectedIndexList: indexList,
                selectedOptions: optionsList,
                exclusiveIndex: exclusiveIndex,
            });
        };
    }

    return (
        <Modal isVisible={showRatingModal}
            hasBackdrop={hasBackdrop}
            animationOut={"slideOutDown"}
            deviceHeight={AppTheme.modalHeight}
            backdropOpacity={AppTheme.modalBackdropOpacity}
            animationOutTiming={AppTheme.modalAnimationDuration}
            onBackdropPress={() => closeModal()}>
            <View style={[AppStyles.modalContainer, { padding: 0, borderRadius: 12 }]}>
                <View style={[AppStyles.topBorderView, AppStyles.p16, { marginBottom: 2 }]}>
                    <View style={[AppStyles.flexRowSpaceBetween]}>
                        <Text style={[TextStyle.text14b, { position: 'relative', }]}>
                            Rate your experience with {orderData?.pharmacyData?.name}?</Text>
                        <CloseIcon action={() => { closeRateModelAndReset(); }} />
                    </View>
                </View>
                <View style={[AppStyles.bottomBorderView, AppStyles.p16,
                { backgroundColor: Colors.background }]}>
                    <View style={styles.ratingView}>
                        {ratingList.map((star: any, i) => {
                            return <Text key={i} onPress={() => {
                                setSelectedRating(i + 1);
                                updateSelectedOption({ selectedIndexList: [], selectedOptions: [], exclusiveIndex: -1 })
                            }}>
                                {selectedRating <= i ?
                                    <Image source={{ uri: getImagePath('/images/pharmacyProfile/polygon4.svg') }}
                                        style={{ width: 30, height: 28, margin: 8 }} /> :
                                    <Image source={{ uri: getImagePath('/images/pharmacyProfile/polygon3.svg') }}
                                        style={{ width: 30, height: 28, margin: 8 }} />}
                            </Text>
                        })}
                    </View>

                    {selectedRating > 0 ? <Text style={styles.reviewLabel}>{ReviewLabel[selectedRating - 1]['dispStr']}</Text> : null}

                    {selectedRating === 0 ? null : <View>
                        {selectedRating > 3 ? <View style={OmsStyles.flexRowWrap}>
                            {PositiveReviews.map((review, index) => <View key={index}>

                                <Text onPress={() => onOptionSelected(index, review)} style={[TextStyle.text14b, {
                                    margin: 4,
                                    paddingHorizontal: 12, paddingVertical: 8, borderRadius: 8,
                                    borderColor: Colors.primary, borderWidth: 1,
                                    color: checkOptionSelected(index) ? '#FFFFFF' : Colors.primary,
                                    backgroundColor: checkOptionSelected(index) ? Colors.primary : '#FFFFFF'
                                }]} >
                                    {review.dispStr}</Text>

                            </View>)}
                        </View> : <View style={OmsStyles.flexRowWrap}>
                            {NegativeReviews.map((review, index) => <View key={index}>

                                <Text onPress={() => onOptionSelected(index, review)} style={[TextStyle.text14b, {
                                    margin: 4,
                                    paddingHorizontal: 12, paddingVertical: 8, borderRadius: 8,
                                    borderColor: Colors.primary, borderWidth: 1,
                                    color: checkOptionSelected(index) ? '#FFFFFF' : Colors.primary,
                                    backgroundColor: checkOptionSelected(index) ? Colors.primary : '#FFFFFF'
                                }]} >
                                    {review.dispStr}</Text>

                            </View>)}
                        </View>}
                    </View>}

                    <TextInput numberOfLines={3} multiline={true} style={[styles.addInput, TextStyle.text14b]}
                        onChangeText={(text) => { updateOtherRatingDescp(text) }}
                        placeholder="Anything else to add..." value={otherRatingDescp}></TextInput>

                    <PrimaryCTA title={'SUBMIT'} width={125}
                        disabled={selectedRating == 0}
                        action={() => updateOrderRating()} />
                </View>
            </View>
        </Modal>

    )
}

export default RateOrderModal;

const styles = StyleSheet.create(addFontFamilyStyle({
    reviewLabel: {
        color: '#FBBC05',
        fontSize: 16,
        fontWeight: '600',
        textAlign: 'center',
        paddingBottom: 24,
    },
    ratingView: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginBottom: 12
    },
    modalButton: {
        backgroundColor: Colors.primary,
        textAlign: "center",
        alignContent: "center",
        width: 125,
        paddingHorizontal: 20, paddingVertical: 12,
        borderRadius: 12,
        color: '#fff'
    },
    addInput: {
        borderWidth: 1, borderRadius: 8, width: AppTheme.appWidth - 96, margin: "auto",
        borderColor: Colors.primary, color: Colors.grey.text,
        paddingHorizontal: 16, paddingVertical: 10, marginVertical: 16
    },
}))